import React from 'react';
import HeaderContainer from 'containers/header';
import ErrorContainerOffer from 'containers/error/offer';
import FooterContainer from 'containers/footer';

const ErrorPageOffer = () => {
  return (
    <>
      <HeaderContainer />
      <ErrorContainerOffer />
      <FooterContainer />
    </>
  );
};

export default ErrorPageOffer;
